import { getCvPortalCandidateTokenForCurrentUser } from "./getCvPortalCandidateTokenForCurrentUser";
import { connectAccount } from "./connectAccount";
import { connectedProfiles } from "./connectedProfiles";
import { isLocalIp } from "./isLocalIp";
import { login } from "./login";
import { me } from "./me";
import { whoAmi } from "./whoAmI";
import { recoverFromToken } from "./recoverFromToken";
import { requestEmailVerifiedConnect } from "./requestEmailVerifiedConnect";
import { createAccount } from "./createAccount";
import { createAccountParameterSuggestion } from "./createAccountParameterSuggestion";

export const authAPI = {
  getCvPortalCandidateTokenForCurrentUser,
  login,
  isLocalIp,
  whoAmi,
  me,
  connectedProfiles,
  connectAccount,
  recoverFromToken,
  requestEmailVerifiedConnect,
  createAccount,
  createAccountParameterSuggestion,
};

export type AuthAPI = typeof authAPI;
